// components/AccountTypePage.jsx
import { Controller } from 'react-hook-form';
import SearchableSelect from '../../../../SearchableSelect';

const AccountTypePage = ({
  control,
  errors,
  backendErrors,
  register,
  domains,
  role,
  managerDomain,
  accountTypes,
  isFieldRequired,
  isUpdateMode,
  watch,
  hasError,
  getErrorMessage
}) => {
  const selectedTypeId = watch("typeId");
  const selectedAccountType = accountTypes.find(at => at.id === selectedTypeId);

  return (
    <div className="page-content">
      <div className="page-header mb-4">
        <h2 className="h4 mb-2">Type de Compte</h2>
        <p className="text-muted">
          Sélectionnez le domaine et le type de compte approprié pour commencer.
        </p>
      </div>

      <div className="row">
        <div className="col-md-6">
          {role === "admin" ? (
            <div className="mb-4">
              <label htmlFor="domainId" className="form-label">
                Choisir un domaine {isFieldRequired('domainId') && <span className="text-danger">*</span>}
              </label>
              <select
                {...register("domainId", { required: "Ce champ est requis." })}
                className={`account-type-select ${
                  errors.domainId || backendErrors.domainId || hasError('domainId') ? 'is-invalid' : ''
                }`}
                id="domainId"
              >
                <option value="">Sélectionner un domaine</option>
                {domains.map((domain) => (
                  <option key={domain.id} value={domain.id}>
                    {domain.name}
                  </option>
                ))}
              </select>
              {(errors.domainId || hasError('domainId')) && (
                <div className="invalid-feedback">
                  {errors.domainId?.message || getErrorMessage('domainId')}
                </div>
              )}
            </div>
          ) : role === "manager" && managerDomain ? (
            <>
              <div className="mb-4">
                <label htmlFor="domainName" className="form-label">Domaine :</label>
                <input
                  type="text"
                  className="form-control"
                  id="domainName"
                  value={managerDomain.name}
                  disabled
                />
              </div>
              <input type="hidden" {...register("domainId", { required: true })} />
            </>
          ) : null}
        </div>

        <div className="col-md-6">
          <div className="mb-4">
            <label htmlFor="TypeId" className="form-label">
              Type de compte {isFieldRequired("typeId") && <span className="text-danger">*</span>}
            </label>

            <Controller
              name="typeId"
              control={control}
              rules={{ required: "Ce champ est requis." }}
              render={({ field }) => (
                <SearchableSelect
                  options={accountTypes}
                  value={accountTypes.find((type) => type.id === field.value)}
                  onChange={(selected) => field.onChange(selected?.id || "")}
                  labelKey="name"
                  valueKey="id"
                  searchKeys={["name"]}
                  isDisabled={isUpdateMode}
                  className={`react-select-container ${
                    errors.typeId || backendErrors.typeId || hasError('typeId') ? "is-invalid" : ""
                  }`}
                />
              )}
            />

            {(errors.typeId || hasError('typeId')) && (
              <div className="invalid-feedback d-block">
                {errors.typeId?.message || getErrorMessage('typeId')}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Aperçu du type sélectionné */}
      {selectedAccountType && (
        <div className="alert alert-success mt-3">
          <strong>Type sélectionné :</strong> {selectedAccountType.name}
          <br />
          <small className="text-muted">
            Les champs obligatoires pour ce type de compte seront marqués d'un <span className="text-danger">*</span>
          </small>
        </div>
      )}
    </div>
  );
};

export default AccountTypePage;